if (__PRODUCTION__) {
  __webpack_public_path__ = window.__ACTION__.publicPath
}
